import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Header from "components/Header";
import moment from "moment";
import { toast } from "react-toastify";
import { Box, TextField, Grid, Dialog, DialogTitle, DialogActions, FormControlLabel, Switch, Tooltip } from "@mui/material";
import { getAllTransaction, getAllProperties, deleteTransaction, getAllUnits } from "state/apis";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import AddReceipt from "./AddReceipt";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import DefaultProperty from "components/DefaultProperty";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import Autocomplete from "@mui/material/Autocomplete";
import { getDefaultProperty } from "state";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PaymentsIcon from "@mui/icons-material/Payments";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import StatBox from "components/StatBox";

const Transaction = () => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    const [totalData, setTotalData] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [openAddForm, setOpenAddForm] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [property, setProperty] = React.useState([]);
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const defaultProperty = useSelector((state) => state.global.defaultProperty);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState(null);
    const [units, setFlat] = React.useState([]);
    const [date, setDate] = React.useState({
        from: "",
        to: "",
        unitId: "",
    });
    const dispatch = useDispatch();
    const [role, setRole] = React.useState({});
    const [isSoldProperty, setIsSoldProperty] = React.useState(false);
    const [todayData, setTodayData] = React.useState([]);
    const [todayClosedData, setTodayClosedData] = React.useState([]);
    const [showClosed, setShowClosed] = React.useState(false);

    React.useEffect(() => {
        fetchData();
        fetchProperty();
        fetchRole();
        fetchTodayData();
        if (!defaultProperty) {
            setOpenDefaultProperty(true);
        }
        fetchUnit(defaultProperty);
    }, [page, rowsPerPage, date, showClosed]);

    const fetchRole = async () => {
        const res = await getDefaultProperty(dispatch);
        setIsSoldProperty(res?.data?.property?.isSold);
        if (res?.data?.role && res?.data?.role?.permission) {
            setRole(JSON.parse(res?.data?.role?.permission));
        }
    };

    const fetchUnit = async (id) => {
        const res = await getAllUnits(100, 0, "", id);
        setFlat(res.data);
    };

    const fetchProperty = async () => {
        try {
            const res = await getAllProperties(100000, 0);
            setProperty(res?.property);
        } catch (error) {
            console.error("Error fetching property:", error);
            toast.error("Failed to fetch property. Please try again.");
        }
    };

    const fetchTodayData = async () => {
        try {
            const today = dayjs().format("YYYY-MM-DD");
            const [openRes, closedRes] = await Promise.all([
                getAllTransaction(100000, 0, today, today, "credit", defaultProperty, "", false),
                getAllTransaction(100000, 0, today, today, "credit", defaultProperty, "", true),
            ]);
            setTodayData(openRes?.data || []);
            setTodayClosedData(closedRes?.data || []);
        } catch (error) {
            console.error("Error fetching today's data:", error);
        }
    };

    const fetchData = async () => {
        try {
            // setIsLoading(true);
            const res = await getAllTransaction(
                rowsPerPage,
                page * rowsPerPage,
                date.from,
                date.to,
                "credit",
                defaultProperty,
                date.unitId,
                showClosed
            );
            setData(res?.data);
            setTotalData(res?.totalCount);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to fetch data. Please try again.");
        }
    };
    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleFrom = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setDate((prevData) => ({
            ...prevData,
            from: formattedDate,
        }));
    };
    const handleTo = (date) => {
        const data = date;
        const formattedDate = data.format("YYYY-MM-DD");

        setDate((prevData) => ({
            ...prevData,
            to: formattedDate,
        }));
    };
    const handleAddReceipt = () => {
        setSelectedRow(null);
        setOpenAddForm(true);
    };
    const handleCloseAddForm = () => {
        setOpenAddForm(false);
        setSelectedRow(null);
    };
    const handleSubmitAddReceipt = async () => {
        setOpenAddForm(false);
        setIsLoading(true);
        fetchData();
        fetchTodayData();
    };

    const handleEditClick = (row) => {
        setSelectedRow(row);
        setOpenAddForm(true);
    };

    const handleDeleteClick = (row) => {
        setDeleteItem(row?.id);
        setDeleteConfirmationOpen(true);
    };

    const handleUnitChange = (newValue) => {
        setDate((prevData) => ({
            ...prevData,
            unitId: newValue ? newValue.id : null,
        }));
    };

    const handleDeleteConfirmation = async () => {
        try {
            await deleteTransaction(deleteItem);
            toast.success("Receipt deleted successfully.");
            fetchData();
            fetchTodayData();
            setDeleteConfirmationOpen(false);
        } catch (error) {
            console.error("Error deleting receipt:", error);
            toast.error("Failed to delete receipt. Please try again.");
        }
    };
    const handleDocumentOpen = (url) => {
        window.open(url, "_blank");
    };

    if (isLoading) {
        return (
            <Box sx={{ p: "24px 28px" }}>
                <Header title="Receipts" />
                <Box sx={{ mt: 4, textAlign: "center", color: "#5a6a85" }}>Loading...</Box>
            </Box>
        );
    }

    const allTodayData = [...todayData, ...todayClosedData];
    const totalReceipts = allTodayData.length;
    const totalAmount = allTodayData.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
    const openAmount = todayData.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
    const closedAmount = todayClosedData.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
    const cashReceipts = allTodayData.filter((row) => row?.transactionType === "Cash");
    const cashAmount = cashReceipts.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
    const cashOpen = todayData.filter((row) => row?.transactionType === "Cash");
    const cashOpenAmount = cashOpen.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
    const cashClosed = todayClosedData.filter((row) => row?.transactionType === "Cash");
    const cashClosedAmount = cashClosed.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);

    const chequeReceipts = allTodayData.filter((row) => row?.transactionType === "Cheque");
    const chequeAmount = chequeReceipts.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
    const chequeOpen = todayData.filter((row) => row?.transactionType === "Cheque");
    const chequeOpenAmount = chequeOpen.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
    const chequeClosed = todayClosedData.filter((row) => row?.transactionType === "Cheque");
    const chequeClosedAmount = chequeClosed.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);

    const onlineReceipts = allTodayData.filter(
        (row) => row?.transactionType !== "Cash" && row?.transactionType !== "Cheque"
    );
    const onlineAmount = onlineReceipts.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
    const onlineOpen = todayData.filter(
        (row) => row?.transactionType !== "Cash" && row?.transactionType !== "Cheque"
    );
    const onlineOpenAmount = onlineOpen.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);
    const onlineClosed = todayClosedData.filter(
        (row) => row?.transactionType !== "Cash" && row?.transactionType !== "Cheque"
    );
    const onlineClosedAmount = onlineClosed.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0);

    const formatAmount = (amount) =>
        amount.toLocaleString("en-AE", { minimumFractionDigits: 0 });

    const AedSymbol = ({ size = 14 }) => (
        <img
            src="/aed-symbol.png"
            alt="D"
            style={{ height: size, verticalAlign: "middle", marginRight: 2, mixBlendMode: "multiply" }}
        />
    );

    return (
        <Box sx={{ p: "24px 28px" }}>
            <Header title="Receipts" subtitle="List of Receipt" />
            <Box display="flex" gap="16px" mt="16px" mb="16px">
                <StatBox
                    title="Today's Receipts"
                    value={totalReceipts}
                    increase={<span><AedSymbol size={22} />{formatAmount(totalAmount)}</span>}
                    bgColor="#f5f5f5"
                    description={
                        <span style={{ fontSize: "0.7rem" }}>
                            <span style={{ color: "#2e7d32" }}>Open: {todayData.length} ({formatAmount(openAmount)})</span>
                            {" | "}
                            <span style={{ color: "#c62828" }}>Closed: {todayClosedData.length} ({formatAmount(closedAmount)})</span>
                        </span>
                    }
                    icon={
                        <ReceiptLongIcon
                            sx={{ color: "#5c6bc0", fontSize: "26px" }}
                        />
                    }
                />
                <StatBox
                    title="Today's Cash"
                    value={cashReceipts.length}
                    increase={<span><AedSymbol size={22} />{formatAmount(cashAmount)}</span>}
                    bgColor="#f5f5f5"
                    description={
                        <span style={{ fontSize: "0.7rem" }}>
                            <span style={{ color: "#2e7d32" }}>Open: {cashOpen.length} ({formatAmount(cashOpenAmount)})</span>
                            {" | "}
                            <span style={{ color: "#c62828" }}>Closed: {cashClosed.length} ({formatAmount(cashClosedAmount)})</span>
                        </span>
                    }
                    icon={
                        <AccountBalanceWalletIcon
                            sx={{ color: "#43a047", fontSize: "26px" }}
                        />
                    }
                />
                <StatBox
                    title="Today's Cheque"
                    value={chequeReceipts.length}
                    increase={<span><AedSymbol size={22} />{formatAmount(chequeAmount)}</span>}
                    bgColor="#f5f5f5"
                    description={
                        <span style={{ fontSize: "0.7rem" }}>
                            <span style={{ color: "#2e7d32" }}>Open: {chequeOpen.length} ({formatAmount(chequeOpenAmount)})</span>
                            {" | "}
                            <span style={{ color: "#c62828" }}>Closed: {chequeClosed.length} ({formatAmount(chequeClosedAmount)})</span>
                        </span>
                    }
                    icon={
                        <PaymentsIcon
                            sx={{ color: "#ef6c00", fontSize: "26px" }}
                        />
                    }
                />
                <StatBox
                    title="Today's Online/Other"
                    value={onlineReceipts.length}
                    increase={<span><AedSymbol size={22} />{formatAmount(onlineAmount)}</span>}
                    bgColor="#f5f5f5"
                    description={
                        <span style={{ fontSize: "0.7rem" }}>
                            <span style={{ color: "#2e7d32" }}>Open: {onlineOpen.length} ({formatAmount(onlineOpenAmount)})</span>
                            {" | "}
                            <span style={{ color: "#c62828" }}>Closed: {onlineClosed.length} ({formatAmount(onlineClosedAmount)})</span>
                        </span>
                    }
                    icon={
                        <AccountBalanceIcon
                            sx={{ color: "#7b1fa2", fontSize: "26px" }}
                        />
                    }
                />
            </Box>
            <Paper sx={{ width: "100%", overflow: "hidden", mt: 2.5, borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                <Box display="flex" justifyContent="flex-end" p={2}>
                    <Grid container spacing={1} p={"5px"} alignItems="center">
                        <Grid item xs={3}>
                            <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                options={units}
                                getOptionLabel={(option) => option.unitNumber}
                                value={
                                    date.unitId
                                        ? units.find((unit) => unit.id === date.unitId)
                                        : null
                                }
                                onChange={(event, newValue) => handleUnitChange(newValue)}
                                isOptionEqualToValue={(option, value) => option === value}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.id}>
                                        {option.unitNumber}
                                    </li>
                                )}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth label="Select Unit" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="From"
                                    name="contractFrom"
                                    onChange={handleFrom}
                                    value={date.from ? dayjs(date.from) : null}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "primary.main",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "primary.main",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="To"
                                    name="contractTo"
                                    onChange={handleTo}
                                    value={date.to ? dayjs(date.to) : null}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: "100%",
                                        "& .MuiOutlinedInput-root": {
                                            "&.Mui-focused fieldset": {
                                                borderColor: "primary.main",
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            "&.Mui-focused": {
                                                color: "primary.main",
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={5} container justifyContent="flex-end" alignItems="center" gap={1}>
                            <Tooltip title="Show receipts from closed contracts" arrow>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={showClosed}
                                            onChange={(e) => {
                                                setShowClosed(e.target.checked);
                                                setPage(0);
                                            }}
                                            color="primary"
                                            size="small"
                                        />
                                    }
                                    label={
                                        <span style={{ fontSize: "0.8rem" }}>
                                            Closed Contracts
                                        </span>
                                    }
                                />
                            </Tooltip>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={() => {
                                    setDate({ from: "", to: "", unitId: "" });
                                    setShowClosed(false);
                                    setPage(0);
                                }}
                            >
                                Reset
                            </Button>
                            {role?.receipt?.add && !isSoldProperty && !showClosed && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleAddReceipt}
                                >
                                    Add Receipt
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer sx={{ maxHeight: 900 }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                {/* <TableCell
                                    fontWeight="900"
                                    sx={{
                                        backgroundColor: "#eef1f6",
                                        color: "#1a2138",
                                    }}
                                >
                                    Receipt Number
                                </TableCell> */}
                                <TableCell>Unit Name</TableCell>
                                <TableCell>Cheque Id</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Transaction Type</TableCell>
                                <TableCell>Amount</TableCell>
                                <TableCell>Transaction Date</TableCell>
                                <TableCell>Bank Ref Number</TableCell>
                                <TableCell>Remarks</TableCell>
                                <TableCell>Reverse</TableCell>
                                <TableCell>Attachment</TableCell>
                                {(role?.receipt?.delete || role?.receipt?.update) &&
                                    !isSoldProperty && !showClosed && (
                                        <TableCell>Actions</TableCell>
                                    )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row) => (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                    {/* <TableCell>{row?.receiptNumber}</TableCell> */}
                                    <TableCell>
                                        {row?.unit?.unitNumber ? row?.unit?.unitNumber : "-"}
                                    </TableCell>
                                    <TableCell>
                                        {row?.cheque?.chequeSerialNumber
                                            ? row?.cheque?.chequeSerialNumber
                                            : "-"}
                                    </TableCell>
                                    <TableCell
                                        sx={{ color: row?.type === "debit" ? "red" : "green" }}
                                    >
                                        {row?.type === "debit" ? "Debit" : "Credit"}
                                    </TableCell>
                                    <TableCell>
                                        {row?.transactionType ? row?.transactionType : "-"}
                                    </TableCell>
                                    <TableCell>{row?.amount}</TableCell>

                                    <TableCell>
                                        {row.date ? moment(row.date).format("DD/MM/YYYY") : "-"}
                                    </TableCell>
                                    <TableCell>
                                        {row?.bankRefNumber ? row?.bankRefNumber : "-"}
                                    </TableCell>
                                    <TableCell>{row?.remarks ? row?.remarks : "-"}</TableCell>
                                    <TableCell>{row?.isReverse === true ? "Yes" : "No"}</TableCell>
                                    <TableCell
                                        style={{
                                            cursor: row?.attachment ? "pointer" : "default", // Apply "pointer" only if attachment exists
                                        }}
                                    >
                                        {row?.attachment && (
                                            <Button
                                                onClick={() => {
                                                    if (row?.attachment) {
                                                        handleDocumentOpen(row?.attachment);
                                                    }
                                                }}
                                                variant="contained"
                                                color="primary"
                                            >
                                                View
                                            </Button>
                                        )}
                                    </TableCell>
                                    {(role?.receipt?.delete || role?.receipt?.update) &&
                                        !isSoldProperty && !showClosed && (
                                            <TableCell>
                                                {role?.receipt?.update && !row?.isReverse && (
                                                    <IconButton
                                                        onClick={() => handleEditClick(row)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                )}
                                                {role?.receipt?.delete && (
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => handleDeleteClick(row)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                        )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={totalData}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <AddReceipt
                    open={openAddForm}
                    onClose={handleCloseAddForm}
                    onSubmit={handleSubmitAddReceipt}
                    editData={selectedRow}
                    editMode={!!selectedRow}
                    property={property}
                    canEditDate={!!role?.receipt?.editDate}
                />

                {!defaultProperty && (
                    <DefaultProperty
                        open={openDefaultProperty}
                        onClose={() => handleCloseDefaultProperty}
                    />
                )}

                <Dialog
                    open={deleteConfirmationOpen}
                    onClose={() => setDeleteConfirmationOpen(false)}
                >
                    <DialogTitle fontWeight={"bold"}>Are you sure you want to delete?</DialogTitle>
                    <DialogActions>
                        <Button
                            onClick={() => setDeleteConfirmationOpen(false)}
                            sx={{ color: "#5a6a85" }}
                        >
                            Cancel
                        </Button>
                        <Button onClick={handleDeleteConfirmation} color="error" autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </Paper>
        </Box>
    );
};

export default Transaction;
